var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{staticClass:"copy-icon is-inline-block ml-2",attrs:{"icon-pack":"fa","icon":"copy","size":_vm.size,"type":"is-blue"},nativeOn:{"click":function($event){return _vm.copy.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }